var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.25 41.447c-2.658-1.535-7.008-1.535-9.666 0L1.984 81.63c-2.657 1.535-2.644 4.023.03 5.529l69.539 39.137c2.675 1.505 7.052 1.505 9.727 0l69.539-39.138c2.675-1.505 2.688-3.992.03-5.527l-69.6-40.183z",
    fillOpacity: 0.2,
    fill: "#FF8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.598 13.152c0 5.607-4.545 10.152-10.152 10.152-5.607 0-10.152-4.545-10.152-10.152C113.294 7.545 117.839 3 123.446 3c5.607 0 10.152 4.545 10.152 10.152",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.598 13.152c0 5.607-4.545 10.152-10.152 10.152-5.607 0-10.152-4.545-10.152-10.152C113.294 7.545 117.839 3 123.446 3c5.607 0 10.152 4.545 10.152 10.152z",
    stroke: "#FF7A4C",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.446 13.152a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
    fill: "#FF7A4C"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M72.728 99.569l25.244-6.847-65.922-38.06-25.42 6.745z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M54.28 30.269L32.05 54.663l65.922 38.06 22.474-24.454z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M146.204 61.376L80.446 23.769l-26.167 6.5 66.167 38zM97.972 92.723L58.146 69.73l-1.35.069c-5.434.28-11.902 1.213-14.238 6.127-.879 1.85-.934 3.97-.435 5.973l30.605 17.67 25.244-6.846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.972 92.723l22.474-24.454-34.685-19.92c-.819 2.838-.067 5.973.431 8.94.553 3.293.562 7.152-1.91 9.395-1.897 1.72-4.676 1.94-7.234 2.072l-18.902.974 39.826 22.993z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.446 68.269l25.758-6.893-34.39-19.667c-3.825-.211-7.652-.344-11.484-.337-5.484.01-12.096 1.019-14.258 6.058-.13.302-.221.61-.311.92l34.685 19.919zM67.94 34.724l-3.5 5.572 4.876 2.423s1.25-4.722 4-4.86l-5.375-3.135zM79.19 78.344s-2.624 3.5-5.874 3.375l4.625 3.875s5.875-2.5 6.375-4.375l-5.125-2.875z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F7",
    d: "M72.728 99.569l25.244-6.847-65.922-38.06-25.42 6.745z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M72.728 99.569l25.244-6.847-65.922-38.06-25.42 6.745z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F7",
    d: "M54.28 30.269L32.05 54.663l65.922 38.06 22.474-24.454z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M54.28 30.269L32.05 54.663l65.922 38.06 22.474-24.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F7",
    d: "M146.204 61.376L80.446 23.769l-26.167 6.5 66.167 38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M146.204 61.376L80.446 23.769l-26.167 6.5 66.167 38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.972 92.723L58.146 69.73l-1.35.069c-5.434.28-11.902 1.213-14.238 6.127-.879 1.85-.934 3.97-.435 5.973l30.605 17.67 25.244-6.846z",
    fill: "#76DFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.972 92.723L58.146 69.73l-1.35.069c-5.434.28-11.902 1.213-14.238 6.127-.879 1.85-.934 3.97-.435 5.973l30.605 17.67 25.244-6.846z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.972 92.723l22.474-24.454-34.685-19.92c-.819 2.838-.067 5.973.431 8.94.553 3.293.562 7.152-1.91 9.395-1.897 1.72-4.676 1.94-7.234 2.072l-18.902.974 39.826 22.993z",
    fill: "#76DFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.972 92.723l22.474-24.454-34.685-19.92c-.819 2.838-.067 5.973.431 8.94.553 3.293.562 7.152-1.91 9.395-1.897 1.72-4.676 1.94-7.234 2.072l-18.902.974 39.826 22.993z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.446 68.269l25.758-6.893-34.39-19.667c-3.825-.211-7.652-.344-11.484-.337-5.484.01-12.096 1.019-14.258 6.058-.13.302-.221.61-.311.92l34.685 19.919z",
    fill: "#76DFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.446 68.269l25.758-6.893-34.39-19.667c-3.825-.211-7.652-.344-11.484-.337-5.484.01-12.096 1.019-14.258 6.058-.13.302-.221.61-.311.92l34.685 19.919z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.94 34.724l-3.5 5.572 4.876 2.423s1.25-4.722 4-4.86l-5.375-3.135z",
    fill: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.19 78.344s-2.624 3.5-5.874 3.375l4.625 3.875s5.875-2.5 6.375-4.375l-5.125-2.875z",
    fill: "#76DFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.936 54.122c-3.737-6.745-6.043-24.653 15.73-17.903 21.775 6.75 38.78 24.5 38.78 24.5",
    stroke: "#FF7A4C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.446 28.904v1.5",
    stroke: "#FF7A4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.446 33.171v20.757",
    stroke: "#FF7A4C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.768,2.768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.446 55.313v1.5",
    stroke: "#FF7A4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.551 70.915c12.303 7.346 31.406 16.812 40.64 11.304 14.25-8.5-6.17-20.723-10.255-28.097",
    stroke: "#00BFA5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.851 58.766c-.254 1.474-.137 3.19.158 4.89-2.1-.444-4.188-.968-6.022-1.576-1.453-.482-2.792-.184-2.99.667-.2.85.818 1.93 2.27 2.41 2.343.778 4.975 1.427 7.558 1.96a42.89 42.89 0 0 0 1.765 4.917c.431.974 1.917 1.827 3.318 1.907 1.402.079 2.188-.646 1.757-1.62-.016-.037-.819-1.867-1.535-4.241 4.26.679 7.553.998 7.812 1.023 1.424.136 2.296-.54 1.946-1.507-.104-.287-.303-.568-.57-.824-.632-.608-1.64-1.078-2.64-1.173-.062-.006-3.288-.318-7.39-.973-.263-1.492-.368-2.976-.153-4.221.076-.45-.173-.956-.636-1.401-.427-.41-1.036-.77-1.736-.987-1.46-.452-2.763-.117-2.912.749",
    fill: "#00BFA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauth);
export default __webpack_public_path__ + "static/media/unauth.10957d42f50b7130d368ed63262e73ec.svg";
export { ForwardRef as ReactComponent };